<script setup lang="ts">
import { Breadcrumbs, Page, type Crumb } from '@/components/common/layout'
import { useWorkspaceStore } from '@/store/workspace'
import { computed, reactive } from 'vue'
import { useCrmStore } from './store'
import { Button, EmptyView, Icon } from '@/components/common'
import Row from './components/Pipelines/Row.vue'

const store = useCrmStore()
const workspaceStore = useWorkspaceStore()
const { workspace } = workspaceStore

const newPipeline = reactive({
  isOpen: false,
  name: '',
})

const crumbs = computed<Crumb[]>(() => [
  {
    title: `${workspace?.title} CRM`,
    url: { name: 'CRMContacts' },
  },
  {
    title: 'Pipelines',
  },
])

const handleCreate = () => {
  newPipeline.name.length &&
    store.createPipeline(newPipeline.name).then(() => {
      newPipeline.name = ''
      newPipeline.isOpen = false
    })
}
</script>
<template>
  <Page>
    <template #topBar>
      <Breadcrumbs :crumbs="crumbs" />
      <Button
        icon="plusSmall"
        size="2"
        variant="outline"
        theme="neutral"
        @click="newPipeline.isOpen = true"
        >Create pipeline</Button
      >
    </template>
    <EmptyView
      v-if="
        store.pipelines.length === 0 &&
        store.isStatus('loaded') &&
        !newPipeline.isOpen
      "
      :class="$style.empty"
      icon="layoutColumn"
      title="You don't have any pipelines yet."
      description="Pipelines are a great way to organize your contacts in a lists and track various progress stages."
    >
      <Button
        icon="plusSmall"
        size="2"
        variant="outline"
        theme="neutral"
        @click="newPipeline.isOpen = true"
        >Create pipeline</Button
      >
    </EmptyView>
    <template v-else>
      <h2 :class="$style.heading">{{ workspace?.title }} Pipelines</h2>
      <table :class="$style.table">
        <tbody>
          <Row
            v-for="pipeline in store.pipelines"
            :key="pipeline.id"
            :pipeline="pipeline"
          />
          <tr v-if="newPipeline.isOpen">
            <td width="32">
              <span :class="$style.pipelineIcon">
                <Icon icon="plusSmall" :size="20" />
              </span>
            </td>
            <td colspan="4">
              <input
                v-model="newPipeline.name"
                v-focus
                :class="$style.textField"
                placeholder="add name for new pipeline"
                @keypress.enter="handleCreate"
              />
            </td>
          </tr>
        </tbody>
      </table>
    </template>
  </Page>
</template>
<style module lang="scss">
@import url(./components/Pipelines/common.module.scss);

.heading {
  @extend .semibold-6;
  margin: var(--page-margin) 0px;
}
.empty {
  margin-top: 64px;
}
.table {
  width: 100%;

  tr {
    td {
      padding: 12px 0px;
      vertical-align: middle;
      transition: background-color 0.1s;
      padding-left: 16px;

      &:last-child {
        padding-right: 16px;
      }
    }

    &:hover {
      td {
        background-color: var(--neutral-alpha-3);
      }
    }
  }

  tr:not(:last-child) {
    td {
      border-bottom: 1px solid var(--neutral-alpha-3);
    }
  }
}
</style>
